import { observer } from 'mobx-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { computed } from 'mobx';
import getFilteredDateFormatOptions from '../utils/getFilteredDateFormatOptions';
import selectDateFormatOption from '../data/mutators/selectDateFormatOption';
import strings from 'owa-strings/owa-options-strings';
import { formatDate, today, addMonths, startOfYear } from 'owa-datetime';
import { format } from 'owa-strings';

let styles = require('./Regional.scss');

// EXAMPLE_DATE will be the next Sep 1st.
const EXAMPLE_DATE = addMonths(startOfYear(addMonths(today(), 4)), 8);

/**
 * Interface for date format selection props
 */
export interface DateFormatSelectionProps {
    showExampleWithDateFormatLabel: boolean;
    onSave?: (newDateFormat: string) => void;
    isQuick?: boolean;
}

@observer
export default class DateFormatSelection extends React.Component<DateFormatSelectionProps, {}> {
    render() {
        let savedDateFormat = getUserConfiguration().UserOptions.DateFormat;
        let selectedKey = getRegionalOptions().selectedDateFormat || savedDateFormat;

        if (getFilteredDateFormatOptions().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredDateFormatOptions().indexOf(savedDateFormat) === -1
                    ? getFilteredDateFormatOptions()[0]
                    : savedDateFormat;
        }
        const label: string = this.props.showExampleWithDateFormatLabel
            ? format(strings.option_regional_dateFormat, EXAMPLE_DATE.getFullYear().toString())
            : strings.option_regional_dateFormatWithoutExample;
        return (
            <Dropdown
                label={this.props.isQuick ? undefined : label}
                options={this.dateFormatOptions}
                selectedKey={selectedKey}
                onChanged={this.onSelectDateFormat}
                styles={{ label: styles.dropdown }}
            />
        );
    }

    private onSelectDateFormat = (item: IDropdownOption) => {
        if (this.props.onSave) {
            this.props.onSave(item.key as string);
        } else {
            selectDateFormatOption(item.key as string);
        }
    };

    @computed
    private get dateFormatOptions() {
        return getFilteredDateFormatOptions().map(shortDateFormat => {
            return {
                text: formatDate(EXAMPLE_DATE, shortDateFormat),
                key: shortDateFormat,
            };
        });
    }
}
